<template>
	<div class="allbg">
		<!-- 头 -->
		<tyheader pageind="7"/>
		<section class="n_banner" style="overflow: hidden;display: flex;align-items: center;">
			<img :src="bannerurl" style="width: 100%;height: 100%;">
		</section>
		<section class="n_title n_title01">
			<div class="w1400 pagetit">
				<div class="left" style="position: relative;z-index: 999;">
					<div class="n_nav">
						<div v-for="(item, index) in newsmenu" :key="index" style="min-width: 110px;display: inline-block;">
							<a v-if="item.linkContent" :href="item.linkContent" target="_blank" :class="{on:newstabind == index}" style="cursor: pointer;"><strong>{{item.title}}</strong></a>
							<a v-else :class="{on:newstabind == index}" @click="otherrout(item.code,index)" style="cursor: pointer;"><strong>{{item.title}}</strong></a>
						</div>
						<!-- <a v-for="(item, index) in newsmenu" v-if="item.linkContent" :href="item.linkContent" :key="index" :class="{on:newstabind == index}" style="cursor: pointer;"><strong>{{item.title}}</strong></a>
						<a v-for="(item, index) in newsmenu" v-if="!item.linkContent" :key="index" :class="{on:newstabind == index}" @click="otherrout(item.code,index)" style="cursor: pointer;"><strong>{{item.title}}</strong></a> -->
						<!-- <a class="on" href="#"><strong>营销网络</strong></a>
						<a href="#"><strong>防伪查询</strong></a>
						<a href="#"><strong>经营者信息</strong></a>
						<a href="#"><strong>线上购买</strong></a>
						<a href="#"><strong>投诉打假</strong></a>
						<a href="#"><strong>用户反馈</strong></a> -->
					</div>
				</div>
				<div class="right ">
					<div class="position"><a href="#">首页</a> <i>-</i> <a href="/yxfw?type=&index=6">服务支持</a> <i>-</i> <em>{{newstabname}}</em> </div>
				</div>
			</div>
		</section>
		<section class="n_container">
			<div class="w1400">
				<div v-if="newslist.intro == 1" class="tsmod">
					<el-form ref="form" :model="form" label-width="80px">
					  <el-form-item label="姓名">
					    <el-input v-model="form.name" placeholder="请输入姓名"></el-input>
					  </el-form-item>
						<el-form-item label="手机号">
						  <el-input v-model="form.phone" placeholder="请输入手机号码"></el-input>
						</el-form-item>
						<el-form-item label="电子邮箱">
						  <el-input v-model="form.email" placeholder="请输入电子邮箱"></el-input>
						</el-form-item>
					  <el-form-item label="内容">
					    <el-input type="textarea" v-model="form.content" placeholder="请输入内容"></el-input>
					  </el-form-item>
					  <el-form-item>
					    <el-button type="success" @click="onSubmit">提 交</el-button>
					    <!-- <el-button>取消</el-button> -->
					  </el-form-item>
					</el-form>
				</div>
				<div v-else v-html="newslist.content"></div>
				<div v-if="newstabind == 4">
						<baidu-map class="map" :center="map.center" :zoom="map.zoom" @ready="handler">
								<!--缩放-->
								<bm-navigation anchor="BMAP_ANCHOR_TOP_LEFT"></bm-navigation>
								<!--定位-->
								<bm-geolocation anchor="BMAP_ANCHOR_BOTTOM_RIGHT" :showAddressBar="true" :autoLocation="true"></bm-geolocation>
								<!--点-->
								<bm-marker :position="map.center" :dragging="map.dragging" animation="BMAP_ANIMATION_DROP">
										<!--提示信息-->
										<bm-info-window :show="map.show">江苏双沟酒业股份有限公司</bm-info-window>
								</bm-marker>
						</baidu-map>
				</div>
				
				
				<!-- <div class="result-container">
				  <div class="responsive-tables">
						<table>
							<thead>
								<tr>
									<th class="head-tit1">事业部</th>
									<th class="h-tit head-tit2">分公司名称</th>
									<th class="h-tit head-tit3">负责人</th>
									<th class="head-tit4">电话</th>
								</tr>
							</thead>
							<tbody>
								<tr>
									<td class="text-C"><a href="#">双沟苏北大区</a></td>
									<td class="text-C">综合处</td>
									<td class="text-C">单岩知</td>
									<td class="text-L">13805143899</td>
								</tr>
								<tr>
									<td class="text-C"><a href="#">双沟苏南大区</a></td>
									<td class="text-C">综合处</td>
									<td class="text-C">周戈明</td>
									<td class="text-L">19898299519</td>
								</tr>
								<tr>
									<td class="text-C"><a href="#">双沟河南大区</a></td>
									<td class="text-C">综合处</td>
									<td class="text-C">王大伟</td>
									<td class="text-L">15951296166</td>
								</tr>
								<tr>
									<td class="text-C"><a href="#">双沟苏南大区</a></td>
									<td class="text-C">综合处</td>
									<td class="text-C">汪志博</td>
									<td class="text-L">13814056234</td>
								</tr>
							</tbody>
						</table>
					</div>
				</div> -->
			</div>
		</section>
		<tyfooter></tyfooter>
	</div>
</template>

<script>
	import tyheader from './header.vue'
	import tyfooter from './footer.vue'
	export default {
	  name: 'product',
		components: {
			tyheader,
			tyfooter
		},
		metaInfo () {
			return {
				title: this.seot,
				meta: [   // set meta
					{                
						name: 'keyWords',
						content: this.seok
					},
					{
						name: 'description',
						content: this.seod
					}
				]
			}
		},
		data(){
			return{
				seot:this.COMMON.seotit,
				seod:this.COMMON.seodec,
				seok:this.COMMON.seokey,
				isshow:this.COMMON.isshow(),
				imgurl:this.COMMON.imgurl,
				bannerurl:'',
				newstabind:0,
				newsmenu:'',
				newstabname:'',
				newslist:'',
				oldcode:'',
				form:{
					content:'',
					name:'',
					phone:'',
					email:'',
				},
				map:{
					center: {lng: 118.190577, lat: 33.224791},
					zoom: 15,
					show: true,
					dragging: true
				},
			}
		},
		computed:{
			
		},
		mounted() {
			let that = this
			let artcode = this.$route.query.type
			let artind = this.$route.query.ind
			let menuindex = this.$route.query.index
			that.oldcode = this.$route.query.type
			that.newstabind = this.$route.query.ind
			that.menuindex = this.$route.query.index
			that.$axios.post('/w/menu').then(function (response) {
				that.bannerurl = that.imgurl + response.data[6].banner
			}).catch(function (error) {
					console.log(error);
			});
			that.getaboutlist()
			that.$axios.post('/w/pageseo?address='+'/yxfw').then(function (response) {
				if(JSON.stringify(response.data) != "{}"){
					that.seot = response.data.seoTitle
					that.seok = response.data.seoKey
					that.seod = response.data.seoDes
				}
			}).catch(function (error) {
					console.log(error);
			});
		},
		methods:{
			handler ({BMap, map}) {
			                let me = this;
			                console.log(BMap, map)
			                // 鼠标缩放
			                map.enableScrollWheelZoom(true);
			                // 点击事件获取经纬度
			                map.addEventListener('click', function (e) {
			                    console.log(e.point.lng, e.point.lat)
			                })
			            },
			getaboutlist(){
				let that = this
				this.$axios.post('/w/menu?code=1631174240047').then(function (response) {
					if(that.oldcode && that.newstabind){
						that.getnewslist(that.oldcode,that.newstabind)
					}else{
						that.getnewslist(response.data[0].code,0)
					}
					that.newsmenu = response.data
					
				})
				.catch(function (error) {
					console.log(error);
				});
			},
			getnewslist(num,ind){
				let that = this
				this.$axios.post('/w/art?code=&&amount=&&page=&&menuCode='+num).then(function (response) {
					
					that.newslist = response.data.list[0]
					that.newstabind = ind
					that.newstabname = that.newslist.title
				})
				.catch(function (error) {
					console.log(error);
				});
			},
			otherrout(num,ind){
				this.$router.push({path:'/yxfw',query: {type:num,ind:ind}})
			},
			onSubmit() {
				let that = this
				console.log('submit!');
				if(that.form.name && that.form.phone && that.form.content && that.form.email){
					that.$axios.post('/w/complaints/in?name='+that.form.name+'&phone='+that.form.phone+'&content='+that.form.content+'&email='+that.form.email).then(function (response) {
						if(response.data.flag == 1){
							that.$message({
								message: '提交成功！',
								type: 'success'
							});
							that.form={content:'',name:'',phone:'',email:'',}
						}
						
					})
					.catch(function (error) {
						console.log(error);
					});
				}else{
					that.$message({
						message: '请填写完整信息！',
						type: 'warning'
					});
				}
			}
		},
		watch:{
			$route(){
				this.oldcode = this.$route.query.type
				this.newstabind = this.$route.query.ind
				this.getaboutlist()
			},
		}
	}
</script>

<style scoped="scoped">
	article, aside, footer, header, nav, section {display: block;}
	img {
	    border-style: none;
	    max-width: 100%;
	    vertical-align: top;
	    width: auto!important;
	    height: auto!important;
	}
	.n_banner {height: 70vh;background-size: cover !important;}
	.n_title {height: 74px;border-bottom: #e7e7ea 1px solid;padding: 0;position: relative;background: #fff;}
	.pagetit{display: flex;justify-content: space-between;}
	.n_nav {position: relative;}
	.n_nav a {display: inline-block;height: 74px;font-size: 18px;float: left;line-height: 75px;color: #333333;text-align: center;box-sizing: border-box;position: relative;-moz-border-radius: 3px;-webkit-border-radius: 3px;border-radius: 3px;margin-right: 3.125rem;}
	.n_nav a:before {content: "";width: 0;height: 3px;position: absolute;bottom: 0;left: 0;background: #119e7f;transition: 0.6s ease-in-out;}
	.n_nav .on:before, .n_nav a:hover:before {width: 100%;}
	.position {line-height: 74px;color: #7b7b7d;padding-left: 22px;font-size: 14px;background: url(../assets/images/home_icon.png) left 30px no-repeat;}
	.position i {
		margin: 0px 5px;
		font-style: normal;
	}
	.position span, .position a, .position i {
		font-size: 14px;
		color: #7b7b7d;
		-moz-transition: all 0.36s ease-in-out;
		-webkit-transition: all 0.36s ease-in-out;
		-o-transition: all 0.36s ease-in-out;
		-ms-transition: all 0.36s ease-in-out;
		transition: all 0.36s ease-in-out;
	}
	.position em {
		font-size: 14px;
		color: #acacac;
		font-style: normal;
	}
	.n_container {
		background: url(../assets/images/n_container_bg.jpg) center bottom no-repeat #fff;
		background-size: 100% auto;
		width: 100%;
		padding: 30px 0px;
	}
	.result-container {
	    display: -webkit-box;
	    display: -webkit-flex;
	    display: -moz-box;
	    display: -ms-flexbox;
	    display: flex;
	    -webkit-flex-wrap: wrap;
	    -ms-flex-wrap: wrap;
	    flex-wrap: wrap;
	    padding: 80px 0;
	}
	.responsive-tables {
	    width: 100%;
	}
	.responsive-tables table {
	    width: 100%;
	    line-height: 1.8;
	    border-collapse: collapse;
	}
	.responsive-tables th {
	    text-align: center;
	    background: #119e7f;
	    /* border: 1px solid #eee; */
	    padding: 16px 5px;
	    font-size: 18px;
	    color: #fff;
	}
	.responsive-tables td {
	    color: #666;
	    background: #fff;
	    text-align: left;
	    border-bottom: 1px solid #f9f9f9;
	    padding: 16px 5px;
	    text-align: center;
	    font-size: 16px;
	}
	.responsive-tables tbody tr:nth-child(2n) td {
	    background: #eee;
	}
	
	.tsmod{
		width: 500px;
		margin: 0 auto;
		text-align: right;
	}
	/deep/ .el-textarea__inner{height: 150px;}
	
	@media screen and (max-width: 767px) {
		.n_title{height: 50px;}
		.n_nav a{height: 50px;line-height: 50px;}
		.position{line-height: 50px;background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAAMCAYAAAC5tzfZAAAAuElEQVQokZXRoU4DQRQF0LOT0RtCkKTB9Qdo+QY0hg+ApAKaFQj6G8XVUlldW40kCMjK6josEMxsMkyWQK95L3PnJJNM1TSNnsxwh0XafyT2gDlu036PI1znF0IBVhnocoV1H6rxhIu+t+I89YcdOsMLxr+ALmM8YxSwxOAP0OUYjwGX+PgngknAK772QG3EAaqieECLIW6Kro4JlGia7SWqQgLlJ58UM0+M2GGD06z4zOZ7dv6G7TfQZhwU9L0NbQAAAABJRU5ErkJggg==) left 19px no-repeat;}
	  .left{width: 7rem;
	  height: 50px;
	  overflow: hidden;}
		.left{background: url(../assets/images/downarr.png) right 15px no-repeat ;background-size: 20px;}
		.left:hover{height:auto;background: url(../assets/images/downarr.png) right 15px no-repeat #ffffff;background-size: 20px;box-shadow: 0px 0px 10px rgb(0,0,0,0.5);}
	}
	
	.map {
			width: 100%;
			height: 400px;
	}
</style>
